<template>
  <div class="bg-white border p-2 mt-3">
    <div class="table-responsive position-relative"
      :class="{ 'with-actions-gap': users.length < 4, 'opacity-50': loading }">
      <table class="table">
        <caption class="sr-only" data-no-export>{{ i18n('User List') }}</caption>
        <thead>
          <tr class="d-none d-lg-table-row">
            <th v-if="this.expiresSoon" scope="col" style="min-width: 48px">&nbsp;</th>
            <th scope="col">{{ i18n('Username') }}</th>
            <th v-if="!this.expiresSoon" @click="orderBy('user_type_id')" scope="col">{{ i18n('Type') }}</th>
            <th @click="orderBy('first_name')" scope="col">{{ i18n('Name') }}</th>
            <th scope="col">{{ i18n('Email') }}</th>
            <th @click="orderBy('company_id')" scope="col">{{ i18n('Company') }}</th>
            <th v-if="this.expiresSoon" data-no-export scope="col">{{ i18n('Expiration date') }}</th>
            <th data-no-export scope="col" style="min-width: 48px">&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <UserListItem v-for="user in users" :user="user" :key="user.id" @edit="showUserModal"
            @deleted="$emit('deleted', $event)" @updated="$emit('updated', $event)"
            @updating="$emit('updating', $event)" :expiresSoon="this.expiresSoon" @updateSelection="handleSelection"
            @ItemExpire="itemExpire" @ItemRenewal="itemRenewal" />
          <EmptyListItem v-if="!users || users.length == 0" :loading="loading" :colspan="7" />
          <LazyLoadListItem v-if="!loading && (lazyLoad || autoLazyLoad)"
            :autoLazyLoad="!pagination.singlePage && autoLazyLoad" :colspan="7" @next="$emit('next', $event)" />
        </tbody>
      </table>
      <div class="position-absolute h-100 w-100 top-0" @click.stop v-if="loading"></div>
    </div>
    <Pagination cssClass="mt-2" v-if="pagination && pagination.singlePage && pagination.limit < pagination.total"
      :pagination="pagination" :loading="loading" @goToPage="(...args) => $emit('goToPage', ...args)" />
  </div>
  <UserModal ref="UserModal" @updated="$emit('updated', $event)" />
</template>

<script>
import UserListItem from "@/components/user/UserListItem.vue";
import UserModal from "@/components/user/UserModal.vue";
import EmptyListItem from "@/components/common/list/EmptyListItem.vue";
import LazyLoadListItem from "@/components/common/list/LazyLoadListItem.vue";
import Pagination from "@/components/common/list/Pagination.vue";
import Tooltip from "@/components/common/layout/Tooltip.vue";

export default {
  components: {
    UserListItem,
    UserModal,
    EmptyListItem,
    LazyLoadListItem,
    Pagination,
    Tooltip,
  },
  emits: [
    'updated',
    'deleted',
    'updated',
    'updating',
    'next',
    'goToPage',
    'orderBy',
    'updateSelection',
    'ItemExpire',
    'ItemRenewal',
  ],
  props: {
    loading: Boolean,
    lazyLoad: Boolean,
    autoLazyLoad: Boolean,
    pagination: Object,
    users: {
      type: Array,
      default() {
        return [];
      },
    },
    expiresSoon: Boolean,
  },
  methods: {
    showUserModal(user) {
      if (!this.$refs.UserModal) return;
      this.$refs.UserModal.show(user.id);
    },
    orderBy(column) {
      if (this.column !== column) {
        this.order = 'asc';
      } else {
        this.order = this.order === 'asc' ? 'desc' : 'asc';
      }

      this.column = column;
      this.$emit('orderBy', `${column},${this.order}`);
    },
    handleSelection(selection) {
      this.$emit('updateSelection', selection);
    },
    itemExpire(user) {      
      this.$emit('ItemExpire', user);
    },
    itemRenewal(user) {      
      this.$emit('ItemRenewal', user);
    },
  },
};
</script>